// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings__toolbar{position:relative;z-index:2}.settings__actions{min-width:360px}.settings .snapshot__container{position:relative}.settings .snapshot__container>.canvas-container{left:0;position:absolute!important;top:0;z-index:1}.settings__canvas{height:100%;position:absolute;width:100%;z-index:99}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
